import { render, staticRenderFns } from "./service-content.vue?vue&type=template&id=e0821082&scoped=true&"
import script from "./service-content.vue?vue&type=script&lang=js&"
export * from "./service-content.vue?vue&type=script&lang=js&"
import style0 from "./service-content.vue?vue&type=style&index=0&id=e0821082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0821082",
  null
  
)

export default component.exports